/**
 * 商城-商品-列表接口
 * @author： xuyd
 * @date：2024-10-01
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 检索列表
   */
  searchSpuList: (params) => {
    return request.post(serviceModule + "/api1/mall/product/searchSpuList", params);
  },

  /**
   * 获取信息
   */
  getImageUrl: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/file/image/getImageUrl", {params});
  },

  /**
   * 上传图片
   *
   * @param params 参数
   * @param fileList 文件列表
   */
  uploadImage: (params, fileList) => {
    return request.uploadWithJson(serviceModule + "/file/image/uploadImage", {formData: params}, {fileList});
  },

  /**
   * 保存商品
   * @param params{商品基础信息，商品-规格，商品sku}
   */
  saveProduct: (params) => {
    return request.post(serviceModule + "/api1/mall/product/saveProduct", params);
  },

  /**
   * 删除
   * @param id 文件id
   */
  deleteProduct: (id) => {
    return request.post(serviceModule + "/api1/mall/product/deleteProduct", {id});
  },

  /////////////////////////////////////////////////////////////////////////////////////

}
